/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Abilities_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Limiting keeps the agent focused and is a good idea for a narrow job. If you are unsure, leave everything on; you can narrow it later." |
*
* @param {Uno_Edu_Agent_Abilities_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_abilities_chip1_answer = /** @type {((inputs?: Uno_Edu_Agent_Abilities_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Abilities_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Beschränkung hält den Agenten fokussiert und lohnt sich bei einer eng umrissenen Aufgabe. Im Zweifel lassen Sie alles an; eingrenzen können Sie später.")
	return /** @type {LocalizedString} */ ("Limiting keeps the agent focused and is a good idea for a narrow job. If you are unsure, leave everything on; you can narrow it later.")
});